import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { Rocket } from "lucide-react";

interface ComingSoonProps {
  onClose?: () => void;
}

export default function ComingSoon({ onClose }: ComingSoonProps = {}) {
  const navigate = useNavigate();

  const handleClose = () => {
    if (onClose) {
      // Modal usage - just close
      onClose();
    } else {
      // Route usage - navigate back to dashboard
      navigate("/dashboard");
    }
  };

  return (
    <Dialog open={true} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent className="sm:max-w-xs bg-sidebar text-white [&>button]:hidden">
        <DialogHeader className="flex flex-col items-center text-center space-y-4">
          <div className="h-16 w-16 rounded-full bg-linear-to-bl from-primary-200/10 via-primary-300/10 to-primary-400/10 flex items-center justify-center text-[#E0B968] mb-2">
            <Rocket className="h-8 w-8" />
          </div>
          <DialogTitle className="text-2xl font-bold">Coming Soon</DialogTitle>
          <DialogDescription className="text-gray-400 text-center text-base w-full">
            Something exciting is on the way. We’ll notify you once it’s live.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-center mt-4">
          <Button
            className="rounded-full w-full bg-linear-to-bl from-primary-200 via-primary-300 to-primary-400 text-black hover:bg-[#d4a84e] min-w-[150px]"
            onClick={handleClose}>
            {onClose ? "Close" : "Back to Dashboard"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
